 import {  USER_LOGOUT,  FETCH_ALL_SELLER_PICKUPS_LIST }    from "actions/actionTypes";



const initialState = {data: [],lastUpdatedAt: '2017-10-15T06:14:23+00:00' };
export default function (state = initialState, action) {
    switch (action.type) {
        case USER_LOGOUT:
            return initialState
        case FETCH_ALL_SELLER_PICKUPS_LIST:
           console.log(FETCH_ALL_SELLER_PICKUPS_LIST, action.payload);
            return {
                data: action.payload.data,
                lastUpdatedAt:new Date(),
            }

        default:
            return state;
    }
}
